module.exports = __webpack_public_path__ + "files/8469c1fe33473ab3031396a5c29a0ad3.svg";